import React from 'react';
import { AxiosResponse } from 'axios';
import { useDispatch } from 'react-redux';
import {
	UseGetDocumentBySignedUrlProps
} from '@data/document/hooks/useGetDocumentBySignedUrl/UseGetDocumentBySignedUrlProps.types';
import { getDocumentBySignedUrlAction } from '@data/documentSignedUrl/actionCreators/DocumentSignedUrlActionCreators';

export const useGetDocumentBySignedUrl = () => {
	const dispatch = useDispatch();

	return React.useCallback(({
		id,
		identifier,
		signedUrl,
		onSuccess: onDocSuccess,
	}: UseGetDocumentBySignedUrlProps) => {
		const onSuccess = ({ data }: AxiosResponse<Blob>) => onDocSuccess(data);
		dispatch(getDocumentBySignedUrlAction({
			id,
			identifier,
			signedUrl,
			onSuccess,
		}));
	}, [dispatch]);
};
